import { z } from 'zod';

export const partnerUserSchema = z.object({
  email: z.string(),
  name: z.string(),
  user_id: z.string(),
});

export const partnerUsersResponseSchema = z.object({
  data: z.array(partnerUserSchema),
});

export type PartnerUserValidated = z.infer<typeof partnerUserSchema>;
export type PartnerUsersResponseValidated = z.infer<typeof partnerUsersResponseSchema>;
